
/* eslint-disable */
import $ from 'jquery';
import 'bootstrap';

// 获取window的宽高
export const getWinSize = () => {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        width = w.innerWidth || e.clientWidth || g.clientWidth,
        height = w.innerHeight || e.clientHeight || g.clientHeight;

    return {
        width,
        height
    }
}

$(function () {
    $('.btn-more, .btn-coo').on('click', function () {
        $('.mask').fadeIn('slow').css('display', 'flex')
    })

    // 关闭扫码加微信弹窗
    $('.doclose').on('click', function () {
        $('.mask').fadeOut('hide')
    })

    // 打开扫码加微信弹窗
    $('#doContact').on('click', function () {
        var mobile = $('#mobile').val()
        console.log('马上联系', mobile)

        if (!mobile) {
            alert('请输入手机号码！！！')
            return
        } else if (!/^1[3456789]\d{9}$/.test(mobile)) {
            alert('请输入正确的手机号码！！！')
            return
        }

        $.ajax({
            url: 'http://dsr.ai.dadaowl.cn/pddUserReg/cms/easyreg',
            type: "POST",
            data: JSON.stringify({
                username: mobile
            }),
            cache: false,
            contentType: 'application/json',
            success: function (res) {
                if (res.code == 200) {
                    $('.mask').fadeIn('slow').css('display', 'flex')
                } else {
                    alert(res.msg)
                }
            },
            error: function (a, b) {
                alert('系统错误')
            }
        });
    })

    // 点击回到顶部按钮
    $('#backToTop').on('click', function (e) {
        console.log('backToTop')
        $('html,body').animate({ scrollTop: 0 }, 400);
    });

    var fadeStart = $(window).height() / 3 // 100px scroll or less will equiv to 1 opacity
        , fadeUntil = $(window).height() // 200px scroll or more will equiv to 0 opacity
        , fading = $('.st-home-unit'),
        windowWidth = $(window).width()
        ;

    // var fadeStart = getWinSize().height / 3 // 100px scroll or less will equiv to 1 opacity
    //     , fadeUntil = getWinSize().height // 200px scroll or more will equiv to 0 opacity
    //     , fading = $('.st-home-unit')
    //     ;


    $(window).on('scroll', function () {
        var offset = $(document).scrollTop()
            , opacity = 0
            ;

        console.log('windowWidth===', windowWidth)
        if (offset <= fadeStart) {
            opacity = 1;
        } else if (offset <= fadeUntil) {
            opacity = 1 - offset / fadeUntil;
        }
        fading.css({ 'opacity': opacity });

        if (offset >= 120) {
            $('.st-navbar').addClass("st-navbar-mini");
            $('.main').addClass("main-mini");
        } else if (offset <= 119) {
            $('.st-navbar').removeClass("st-navbar-mini");
            $('.main').removeClass("main-mini");
        }

        // 回到顶部按钮
        if ($(window).scrollTop() >= 200) {
            $('#backToTop').fadeIn();
        }
        else {
            $('#backToTop').fadeOut();
        }
    });

    // 判断是否手机端访问，修改联系我们a标签href
    var userAgentInfo = navigator.userAgent.toLowerCase();
    var contact = document.querySelector('#contact-link');
    var Agents = ["android", "iphone",
        "symbianos", "windows phone",
        "ipad", "ipod"];
    console.log('userAgentInfo', userAgentInfo)
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) >= 0) {
            console.log(contact)
            contact.href = 'mqqwpa://im/chat?chat_type=wpa&uin=2919508254&amp;site=qq&amp;menu=yes'; // wap端地址
            break;
        } else {
            // contact.href = 'https://wpa.qq.com/msgrd?v=3&amp;uin=2919508254&amp;site=qq&amp;menu=yes' // PC端地址
            contact.href = 'https://wpa.qq.com/msgrd?v=3&uin=2919508254&site=qq&menu=yes' // PC端地址
            console.log(contact.href)
        }
    }
})
